import { buildPathWithMap } from 'authorization';
import { SiteManagmentRoute } from '../domains/site-managment/site-managment.route';
import { AuthenticationRoute } from '../domains/authentication/authentication.route';
import { ThemeRoute } from 'src/domains/theme/theme.route';
import { SchematicsGuiRoute } from 'schematics-gui';
import { ChatBotRoute } from 'src/domains/chat-bot/chat-bot.route';
import { CompanyRoute } from 'src/domains/authentication/domains/company/presenter/routes/company.route';

export class AppRoute {
  static readonly map = {
    root: { ...SiteManagmentRoute.map },
    auth: { ...AuthenticationRoute.map },
    site_managment: { ...SiteManagmentRoute.map },
    theme: { ...ThemeRoute.map },
    schematics: { ...SchematicsGuiRoute.map },
    chat_bot: { ...ChatBotRoute.map },
    company: { ...CompanyRoute.map },
  };
}
export const appRouteIndex = buildPathWithMap(AppRoute.map, '');
